import React from 'react';
const HubspotContext = React.createContext<any>({ setIsActive: () => {}, loaded: false });
export default HubspotContext;
